/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Marketing/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Marketing({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Marketing",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Marketing.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-1rd8jY': alignSelf,'--mt-2-1rd8jY': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1rd8jY': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1rd8jY': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1rd8jY': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1rd8jY': opacity,'--w-10-1rd8jY': typeof width === 'number' ? `${width}px` : width,'--h-11-1rd8jY': typeof height === 'number' ? `${height}px` : height,'--f-12-1rd8jY': fill,'--a-7-1rd8jY': isAnimated ? animation : "none",'--sd-8-1rd8jY': isAnimated ? strokeDashoffset : 0,'--sd-9-1rd8jY': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2Marketing.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_1869_24440)"
 className="views-block"
>
<path
  data-testid="Tysiav2Marketing.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M8.375 2.027a7 7 0 105.265 12.214L8.57 9.454A.625.625 0 018.376 9V2.027zm6.124 11.305A7 7 0 009.625 2.027V8.73l4.874 4.602z"
 style={{'--f-12-1rd8jY': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}